import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button, DashboardModule } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import useBrandGroupPublication from '@hooks/useBrandGroupPublication'
import useBrandGroupPublications from '@hooks/useBrandGroupPublications'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import type { BrandGroupPublicationModel } from '@models/types'

import BrandGroupPublicationListItem from './BrandGroupPublicationListItem'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Publication Title',
    },
  ]
}

const BrandGroupPublications = (props: { brandGroupId: number}) => {
  const { brandGroupId } = props

  const filterPayload = useFilters()
  const { pageFilters } = filterPayload

  const brandGroupPublicationsPayload = useBrandGroupPublications({
    filters: {
      brand_group_id: brandGroupId,
      ...pageFilters,
    },
    performHttpRequests: !!brandGroupId,
    requestOptions: { include_brand_group_publication_publication: true },
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredBrandGroupPublications,
    filteredBrandGroupPublicationsCount,
    hasFilteredBrandGroupPublications,
    loading,
  } = brandGroupPublicationsPayload

  const {
    callbacks: {
      addBrandGroupPublication,
    },
  } = useBrandGroupPublication({ brand_group_id: brandGroupId })

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={hasFilteredBrandGroupPublications && <DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Publications"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      {!loading && !hasFilteredBrandGroupPublications && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Publications present.
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Please adjust your filters or add a Publication.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {!loading && hasFilteredBrandGroupPublications && (
        // @ts-expect-error TS2322
        <DashboardModule.ScrollableSection flexDirection="column" maxHeight={600}>
          {filteredBrandGroupPublications.map((brandGroupPublication: BrandGroupPublicationModel) => (
            <BrandGroupPublicationListItem
              key={brandGroupPublication.id}
              brandGroupPublication={brandGroupPublication}
            />
          ))}
        </DashboardModule.ScrollableSection>
      )}

      <DashboardModule.LoadMoreFooter
        boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredBrandGroupPublicationsCount}
        loading={loading}
      >
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => addBrandGroupPublication()}
          // @ts-expect-error TS2322
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Add Publication
        </Button>
      </DashboardModule.LoadMoreFooter>
    </DashboardModule>
  )
}

export default BrandGroupPublications
